import { createAction, handleActions } from 'redux-actions';
import { Map } from 'immutable';

const CHANGE_NAME = 'form/CHANGE_NAME';
const CHANGE_TEL = 'form/CHANGE_TEL';
const CHANGE_EMAIL = 'form/CHANGE_EMAIL';
const CHANGE_ABOUT = 'form/CHANGE_ABOUT';
const CHANGE_MESSAGE = 'form/CHANGE_MESSAGE';
const RESET_FORM = 'form/RESET_FORM';
const SHOW_NOTICE = 'form/SHOW_NOTICE';
const HIDDEN_NOTICE = 'form/HIDDEN_NOTICE';
const SET_MESSAGE = 'form/SET_MESSAGE';

export const changeName = createAction(CHANGE_NAME); // value
export const changeTel = createAction(CHANGE_TEL);
export const changeEmail = createAction(CHANGE_EMAIL);
export const changeAbout = createAction(CHANGE_ABOUT);
export const changeMessage = createAction(CHANGE_MESSAGE);
export const resetForm = createAction(RESET_FORM);
export const showNotice = createAction(SHOW_NOTICE);
export const hiddenNotice = createAction(HIDDEN_NOTICE);
export const setMessage = createAction(SET_MESSAGE);

const initialState = Map({
  name: '',
  tel: '',
  email: '',
  about: '',
  message: '',
  brand: 'baby deedee',
  notice: false,
  alertMessage: ''
});

export default handleActions({
  [CHANGE_NAME]: (state, action) => {
    const value = action.payload;

    return state.set('name', value)
  },

  [CHANGE_TEL]: (state, action) => {
    const value = action.payload;

    return state.set('tel', value)
  },

  [CHANGE_EMAIL]: (state, action) => {
    const value = action.payload;

    return state.set('email', value)
  },

  [CHANGE_ABOUT]: (state, action) => {
    const value = action.payload;

    return state.set('about', value)
  },

  [CHANGE_MESSAGE]: (state, action) => {
    const value = action.payload;

    return state.set('message', value)
  },
  [RESET_FORM]: (state) => {
    return state.set('name', '').set('tel', '').set('email', '').set('about', '').set('message', '').set('about', '');
  },
  [SHOW_NOTICE]: (state) => {
    return state.set('notice', true);
  },
  [HIDDEN_NOTICE]: (state) => {
    return state.set('notice', false);
  },
  [SET_MESSAGE]: (state, action) => {
    const message = action.payload;

    return state.set('alertMessage', message);
  }
}, initialState);



// WEBPACK FOOTER //
// ./src/modules/form.js